export default __webpack_public_path__ + "static/media/element_40.01d81399.jpg";